var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "map-locations__container" }, [
    _c(
      "h2",
      { staticClass: "map-locations__title map-locations__title--mobile" },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "map" },
      [
        _c(
          "GmapMap",
          {
            staticClass: "map__map map__map--locations",
            attrs: {
              "map-type-id": "roadmap",
              center: _vm.userLocation.lng
                ? _vm.userLocation
                : _vm.defaultLocation,
              zoom: 14,
              options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: true,
                styles: _vm.styles.map,
              },
            },
          },
          [
            _c(
              "gmap-cluster",
              { attrs: { options: { styles: _vm.styles.cluster[0] } } },
              _vm._l(_vm.allLocations, function (m, index) {
                return _c("gmap-marker", {
                  key: index,
                  attrs: { position: m.location, icon: _vm.styles.marker },
                })
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "map-locations__location-block" },
      [
        _c("h2", { staticClass: "map-locations__title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "map-locations__top-container" }, [
          _c("div", { staticClass: "map-locations__input-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              staticClass: "map-locations__input",
              attrs: {
                type: "text",
                placeholder: "Enter location or postcode",
              },
              domProps: { value: _vm.query },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchUserLocation.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.query = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "map-locations__input-subtitle" }, [
              _vm._v("\n          " + _vm._s(_vm.subtitle) + "\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "map-locations__button",
              on: { click: _vm.searchUserLocation },
            },
            [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("locations", {
          attrs: {
            locations: _vm.theLocations,
            "user-location": _vm.userLocation,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }